import { ActivatedRouteSnapshot, CanActivate, Params, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { DivisionGuardService, OrganizationInfos } from '@damofire/data-stas';

export abstract class OrganizationInfosGuardianMinionService<T extends OrganizationInfos<any>> implements CanActivate {
  protected constructor(
    protected readonly router: Router,
    protected readonly authService: DivisionGuardService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    try {
      const isASystemAdministrator = await this.authService.hasRole(route.data.adminSystemRole);
      if (!isASystemAdministrator) {
        const dto = await this.resolveTargetDto(route.params);

        if (!dto || dto.enabled === false) {
          console.log(`Could not find target dto or it's disabled`, dto, route.params);
          return this.router.parseUrl('/404');
        }

        const canReadOrg = await this.authService.canReadOrg(dto.organization._id);
        const canReadDiv = await this.authService.canReadDivision(dto.division._id);

        if (!canReadOrg && !canReadDiv) {
          return this.router.parseUrl('/403');
        }
      }
    } catch (err) {
      // On assume un problème avec les rules si on arrive ici, donc on a pas le droit.
      console.error(err);
      return this.router.parseUrl('/403');
    }

    return true;
  }

  abstract resolveTargetDto(params: Params): Promise<T>;
}
